module.exports = __webpack_public_path__ + "static/media/7_zemly_0_88.52.bdcf9d55.png";